/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Badge_DeepInputs */

const en_model_badge_deep = /** @type {(inputs: Model_Badge_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep`)
};

const id_model_badge_deep = /** @type {(inputs: Model_Badge_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendalam`)
};

/**
* | output |
* | --- |
* | "Deep" |
*
* @param {Model_Badge_DeepInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_badge_deep = /** @type {((inputs?: Model_Badge_DeepInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Badge_DeepInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_badge_deep(inputs)
	return en_model_badge_deep(inputs)
});